var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08724 17.1559C4.48474 17.1559 0.753906 13.4251 0.753906 8.82259C0.753906 4.22009 4.48474 0.489258 9.08724 0.489258C13.6897 0.489258 17.4206 4.22009 17.4206 8.82259C17.4206 13.4251 13.6897 17.1559 9.08724 17.1559ZM9.08724 15.4893C10.8554 15.4893 12.551 14.7869 13.8013 13.5366C15.0515 12.2864 15.7539 10.5907 15.7539 8.82259C15.7539 7.05448 15.0515 5.35879 13.8013 4.10855C12.551 2.8583 10.8554 2.15592 9.08724 2.15592C7.31913 2.15592 5.62344 2.8583 4.37319 4.10855C3.12295 5.35879 2.42057 7.05448 2.42057 8.82259C2.42057 10.5907 3.12295 12.2864 4.37319 13.5366C5.62344 14.7869 7.31913 15.4893 9.08724 15.4893ZM9.92057 8.82259H13.2539V10.4893H8.25391V4.65592H9.92057V8.82259Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.4bc9901eb729d1de337101d584e5be96.svg";
export { ForwardRef as ReactComponent };